import React from 'react'

export type StarFilledIconProps = React.HtmlHTMLAttributes<SVGElement>

export const StarFilledIcon: React.FC<StarFilledIconProps> = ({
  ...svgProps
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M13.0003 2.16699L16.3478 8.94866L23.8337 10.0428L18.417 15.3187L19.6953 22.772L13.0003 19.2512L6.30533 22.772L7.58366 15.3187L2.16699 10.0428L9.65283 8.94866L13.0003 2.16699Z"
        fill="currentColor"
      />
    </svg>
  )
}
